import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import type { KeyFieldsLockOptions } from "web_myplann/Shared/Validation/lockableField";
import { refineRequiredMinimum } from "web_myplann/Shared/Validation/refineRequiredMinimum";

export const CONTRACT_REQUIRED_MINIMUM_FIELDS = [
	"name",
	"contractNumber",
	"producer",
	"product",
] as const;

type ContractRequiredMinimumField =
	(typeof CONTRACT_REQUIRED_MINIMUM_FIELDS)[number];

export const refineContractRequiredMinimum = refineRequiredMinimum(
	CONTRACT_REQUIRED_MINIMUM_FIELDS,
);

const skipRefinement = () => undefined;

export const getContractRequiredMinimumRefinement = ({
	lockKeyFields = false,
}: KeyFieldsLockOptions = {}) =>
	lockKeyFields ? skipRefinement : refineContractRequiredMinimum;

export const getContractRequiredMinimumMessage = (
	t: TranslateFunction,
	fieldLabels: Record<ContractRequiredMinimumField, string>,
) =>
	t(Resources.Portfolio.AddShared.Validations.requiredMinimum, {
		fields: [
			t(fieldLabels.name),
			t(fieldLabels.contractNumber),
			t(fieldLabels.product),
		].join(", "),
		lastField: t(fieldLabels.producer),
	});
